// extracted by mini-css-extract-plugin
export var congratsText = "progressInfo-module--congratsText--sNW-+";
export var title = "progressInfo-module--title--2iifd";